module.exports = __webpack_public_path__ + "static/media/anatomia.e8d51e6f.png";